export class StreamersApplicationService {
    constructor(streamersGateway) {
        this.streamersGateway = streamersGateway;
    }
    isStreamerRegistered(username) {
        return this.streamersGateway.hasStreamerRegistered(username);
    }
    retrieveAllStreamers() {
        return this.streamersGateway.retrieveAllStreamers();
    }
    registerStreamer(username) {
        return this.streamersGateway.hasStreamerRegistered(username)
            .then(hasStreamerRegistered => hasStreamerRegistered
            ? Promise.resolve()
            : this.streamersGateway.registerStreamer({ username }))
            .catch(error => Promise.reject(error));
    }
}
